/**
 * Ролик на странице акции.
 *
 * Загруженный файл проигрывается своим плеером, ссылка на YouTube или Vimeo —
 * их встроенным. Ничего другого не вставляем: произвольный iframe на странице
 * акции — это чужой код на нашем домене.
 */

import { useT } from '@allswipes/i18n';
const YOUTUBE = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/;
const VIMEO = /vimeo\.com\/(?:video\/)?(\d+)/;

export function CampaignVideo({ url }: { url: string }) {
  const t = useT();
  const youtube = url.match(YOUTUBE);
  if (youtube) {
    return (
      <div className="vwrap">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${youtube[1]}`}
          title={t('Видео акции')}
          allow="accelerometer; clipboard-write; encrypted-media; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  const vimeo = url.match(VIMEO);
  if (vimeo) {
    return (
      <div className="vwrap">
        <iframe
          src={`https://player.vimeo.com/video/${vimeo[1]}`}
          title={t('Видео акции')}
          allow="fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
    );
  }

  if (!/^https?:\/\//.test(url)) return null;

  return (
    <div className="vwrap">
      <video src={url} controls preload="metadata" playsInline />
    </div>
  );
}
